import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useEffect } from 'react'
import { userLogin } from '../../store/actions/apiActions'
import { Jackpots } from '../Mobile/Mobile'

const JackpotPage = () => {
	const jackpot = useSelector((state) => state?.jackpot, shallowEqual)
	const { t } = useTranslation()
	const dispatch = useDispatch()
	console.log('jackpot', jackpot)
	const userData = useSelector((state) => state?.userdata, shallowEqual)

	useEffect(() => {
		if (!userData.auth) {
			dispatch(userLogin())
		}

		// Set the background to transparent
		document.body.style.background = 'transparent'

		return () => {
			document.body.style.background = ''
		}
	}, [])

	return (
		<div
			style={{
				display: 'flex',
				width: '100%',
				flexFlow: 'column',
			}}
		>
			<Jackpots />
		</div>
	)
}

export default JackpotPage
